import initialState from './initialState.js'

export const resetState = (state) => {
  const s = initialState()

  Object.keys(s).forEach(key => {
    state[key] = s[key]
  })
}

export const addItemsToFeed = (state, items) => {
  state.feed.push.apply(state.feed, items)
}

export const addNewItems = (state, items) => {
  state.newItems.push.apply(state.newItems, items)
}

export const prependNewItems = (state) => {
  state.feed.unshift.apply(state.feed, state.newItems)
  state.newItems = []
}

export const setGroupId = (state, groupId) => {
  state.group_id = groupId
}

export const setMinTimestamp = (state, minTimestamp) => {
  state.minTimestamp = minTimestamp
}

export const setMaxTimestamp = (state, maxTimestamp) => {
  state.maxTimestamp = maxTimestamp
}
